module.exports = __webpack_public_path__ + "img/shop-zappos.b9dd479a.png";